import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class tablePlayerPrizesLoyaltyView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // Unique ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'ch1',
                                    header: { content: 'masterCheckbox' }, // Header for master checkbox
                                    checkValue: 'on', // Value when checked
                                    uncheckValue: 'off', // Value when unchecked
                                    width: 40,
                                    hidden: !devConfig.getPermAction('changeStateGiftAll', 'Edit'), // Conditional visibility based on permissions
                                    css: 'prm-changeStateGiftAll', // CSS class for styling
                                    template: function (obj, type, value) {
                                        // Template for checkbox rendering
                                        if (
                                            (obj.ResultTypeId == 4 && obj.TypeAward == 1) ||
                                            (obj.ResultTypeId == 4 && obj.TypeAward == 0 && obj.WayToPay == 3)
                                        ) {
                                            if (value == 'on') {
                                                return (
                                                    `<input value=` +
                                                    obj.Id +
                                                    ` class="webix_table_checkbox" type="checkbox" checked="true">`
                                                ); // Render checked checkbox
                                            } else {
                                                return (
                                                    `<input value=` +
                                                    obj.Id +
                                                    ` class="webix_table_checkbox" type="checkbox">`
                                                ); // Render unchecked checkbox
                                            }
                                        } else {
                                            return ``; // No checkbox rendered
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: _('ID'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'GiftId',
                                    header: _('Id Regalo'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateModified',
                                    header: _('Fecha Modificó'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'PlayerExternalId',
                                    header: _('Id Usuario'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'CasinoId',
                                    header: _('Id Casino'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'ResultTypeId',
                                    header: _('Estado'), // Localized header
                                    width: 100,
                                    options: [
                                        { id: '4', value: _('Comprado') }, // Localized option
                                        { id: '5', value: _('Entregado') }, // Localized option
                                    ],
                                },
                                {
                                    id: 'Prize',
                                    header: _('Descripción Premio'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'TypeAward',
                                    header: _('Tipo Premio'), // Localized header
                                    width: 100,
                                    options: [
                                        { id: '1', value: _('Online') }, // Localized option
                                        { id: '0', value: _('Físico') }, // Localized option
                                    ],
                                },
                                {
                                    id: 'CityBetShop',
                                    header: _('Ciudad'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'BetShopId',
                                    header: _('Id punto de venta'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'BetShop',
                                    header: _('Punto de venta'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Names',
                                    header: _('Nombres'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Surnames',
                                    header: _('Apellidos'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Identification',
                                    header: _('Identificación'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Phone',
                                    header: _('Teléfono'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'City',
                                    header: _('Ciudad'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Address',
                                    header: _('Dirección'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Team',
                                    header: _('Equipo'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'LoyaltyLevel',                           // Unique identifier for the column, used internally
                                    header: _('Nivel del jugador'),               // Column title (translated based on the language)
                                    width: 150,                                   // Column width in pixels
                                    sort: 'int',                                  // Sorting type: integer number
                                },
                                {
                                    id: 'RequiredLevelGift',                      // Unique identifier for the column, used internally
                                    header: _('Nivel Requerido del Regalo'),      // Column title (translated based on the language)
                                    width: 150,                                   // Column width in pixels
                                    sort: 'int',                                  // Sorting type: integer number
                                },
                                {
                                    id: 'Observation',
                                    header: _('Observación'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            onClick: {
                                // Event handlers for clicks
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    if (screen.width < 500 || screen.height < 500) {
                                        // Check screen size
                                        $$('filterDetails').show(); // Show filter details
                                    } else {
                                        $$('dColl').expand(); // Expand details
                                    }
                                },
                            },
                            on: {
                                // Event handlers for DataTable
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with OverlayBox
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                        _('No hay datos') +
                                        '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Get DataTable instance
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = devConfig.geturlApi() + 'es/Report/GetLoyaltyPlayers?PlayerExternalId=' + cur_user + '&'; // API URL for fetching data
        var filter = ''; // Filter string

        this.on(this.app, 'playerPrizesLoyaltyReport:filter', (filterData) => {
            // Event listener for filter updates
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter string
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        this.on(this.app, 'player:select', (id) => {
            // Event listener for player selection
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id); // Load data for selected player
        });
    }
}

// FILE DOCUMENTED
